export default __webpack_public_path__ + "static/media/Interacting1.6e57d3aa.png";